import React from 'react';
import { PAGE_PREFIX, PLATFORM_PAGES } from './platforms';

// Short "dedicated downloaders" section for the how-to articles.
// Plain <a href> links (crawlable) with descriptive anchor text, built from
// the same list as the pages themselves, so URLs and the prefix never drift.
const BLURBS = {
  instagram: 'save reels, videos and photos from Instagram',
  tiktok: 'save TikTok videos and audio',
  youtube: 'save YouTube videos and audio in your preferred quality',
  facebook: 'save Facebook videos and reels',
  twitter: 'save videos and GIFs from tweets',
};

export default function PlatformDownloaderLinks({ first }) {
  const pages = Object.values(PLATFORM_PAGES);
  const ordered = first
    ? [...pages.filter((p) => p.id === first), ...pages.filter((p) => p.id !== first)]
    : pages;

  return (
    <section style={{ marginTop: '32px', paddingTop: '16px', borderTop: '1px solid #e5e5e5' }}>
      <h2 style={{ fontSize: '18px', marginBottom: '8px' }}>Also try our downloaders for each platform</h2>
      <p>
        Prefer a page made for one site? Each Downr downloader below works the same way as the
        steps above and only accepts links from its own platform:
      </p>
      <ul style={{ paddingLeft: '20px', lineHeight: 1.8 }}>
        {ordered.map((p) => (
          <li key={p.id}>
            <a href={`/${PAGE_PREFIX}/${p.slug}/`}>Downr {p.label} video downloader</a>
            {BLURBS[p.id] ? ` – ${BLURBS[p.id]}` : ''}
          </li>
        ))}
      </ul>
    </section>
  );
}
